import { get } from '@alltrails/core/utils/get';
import type CountryCode from '@alltrails/core/types/CountryCode';
import type CurrencyCode from '@alltrails/core/types/CurrencyCode';
import type { Plan } from '@alltrails/types/Plan';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';

type AvailablePlansResponse = {
  currencyCode: CurrencyCode;
  nonTrial: Plan;
  trial: Plan;
};

export default async function getAvailablePlans(billingCountry: CountryCode, purchaseTier: PurchaseTier) {
  const params = new URLSearchParams();
  params.set('billing_country', billingCountry);
  params.set('subscription_tier', purchaseTier);

  return get<AvailablePlansResponse>(`/api/alltrails/purchases/available_plans?${params.toString()}`);
}
